import { Card, Space, Typography } from "antd";
import React from "react";
import HeadingSubHeading from "../../../../components/ViewHeading/HeadingSubHeading";
import RenderForm from "../../../../components/Forms/Form";
import { DottedLineManagerConfig } from "../../../../entity/Organisations/Employees/Settings/DottedLineManagerConfig";
const { Title, Text } = Typography

const DottedLineManager = () => {
    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <HeadingSubHeading titleProps={{ level: 5 }}
                title={'Dotted Line Manager Settings'}
                subTitle="A dotted line manager is a supervisory figure who can assign tasks to employees,has some form of authority over employees but who is not their direct, or straight line manager" />
            <Card style={{ width: 500 }}>
                <Title level={5}>Dotted Line Manager Settings</Title>
                <Text type="secondary">Dotted Line Manager is a supervisory figure who can assign tasks to employees, has some form of authority over employees but who is not their direct, or straight line manager.</Text>
            </Card>

            <Card style={{ width: 500 }}>
                <RenderForm config={DottedLineManagerConfig} />
            </Card>
        </Space>
    );
}

export default DottedLineManager;